var DropDown = require('../../../../common/dropDown/dropDownWr');


module.exports = DropDown.extend({

    template: require('./noteSortMenu.hbs'),

    templateOptions: function() {
        return {
            sortValDesc: _.chain(this.options.notes.comparators)
                .pairs()
                .map(function(p) {
                    var o = {};
                    o.val = p[0];
                    o.name = p[1].name;
                    return o;
                })
                .sortBy(function(a) {return a.name;}).value()
        };
    },

    onChange: function(value, elData) {
        this.options.channel.command('changeSortOption', elData.sort);
    },

    defaultSelector: function() {
        var sortType = this.options.channel.request('noteSortType');
        return '[data-sort="' + sortType + '"]';
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/header/sort/sortMenu.js
 ** module id = 495
 ** module chunks = 0
 **/